export const S_EMBED_ROUTE_CHANGED_EVENT = "s_embed_route_changed";

const S_TO_HOST_EVENT = {
  surface_changed: S_EMBED_ROUTE_CHANGED_EVENT,
  chat_started: "s_chat_started",
  dashboard_viewed: "s_dashboard_viewed",
  schedules_viewed: "s_schedules_viewed",
  schedule_viewed: "s_schedule_viewed",
  schedule_created: "s_schedule_created",
  schedule_updated: "s_schedule_updated",
  schedule_deleted: "s_schedule_deleted",
  dashboard_created: "s_dashboard_created",
  dashboard_edited: "s_dashboard_edited",
  dashboard_published: "s_dashboard_published",
  dashboard_shared: "s_dashboard_shared",
  dashboard_filter_added: "s_dashboard_filter_added",
  dashboard_filter_removed: "s_dashboard_filter_removed",
  dashboard_filters_applied: "s_dashboard_filters_applied",
  dashboard_filters_reset: "s_dashboard_filters_reset",
  visualisation_pinned: "s_visualisation_pinned",
} as const;

export function toHostAnalyticsEventName(event: string): string | undefined {
  if (event in S_TO_HOST_EVENT) {
    return S_TO_HOST_EVENT[event as keyof typeof S_TO_HOST_EVENT];
  }
  return undefined;
}
